import { render, staticRenderFns } from "./InformationAboutStudentLeavingReport.vue?vue&type=template&id=36a50be4&"
import script from "./InformationAboutStudentLeavingReport.vue?vue&type=script&lang=js&"
export * from "./InformationAboutStudentLeavingReport.vue?vue&type=script&lang=js&"
import style0 from "./InformationAboutStudentLeavingReport.vue?vue&type=style&index=0&id=36a50be4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports